// | ------------------------------------------------------------------------
// | Components - Office Space
// | ------------------------------------------------------------------------

import fsLightbox from "fslightbox";

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  var officeSpaceGallery = document.querySelector(".os-gallery");

  if (officeSpaceGallery) {
    var groundFloorGallery = new FsLightbox();
    groundFloorGallery.props.sources = [
      "/assets/images/office-space/ground-floor/ground-floor-lg.webp?v=2",
      "/assets/images/office-space/ground-floor/g1.webp?v=2",
      "/assets/images/office-space/ground-floor/g2.webp?v=2",
      "/assets/images/office-space/ground-floor/g3.webp?v=2",
      "/assets/images/office-space/ground-floor/g4.webp?v=2",
      "/assets/images/office-space/ground-floor/g5.webp?v=2",
      "/assets/images/office-space/ground-floor/g6.webp?v=2",
      "/assets/images/office-space/ground-floor/g7.webp?v=2",
    ];

    var groundRows = document.querySelectorAll(".ground-floor-table tbody tr");
    var openGroundLinks = document.querySelectorAll(".open-ground");

    openGroundLinks.forEach(function (e) {
      e.addEventListener("click", function () {
        groundFloorGallery.open(0);
      });
    });

    groundRows.forEach(function (row) {
      row.addEventListener("click", function (clickEvent) {
        var i = Array.from(row.parentNode.children).indexOf(row);
        var i = i + 1;
        var officeNumber = Number(i);
        var target = clickEvent.currentTarget;
        if (target.classList.contains("gallery-link")) {
          groundFloorGallery.open(officeNumber);
        }
      });
    });

    // First Floor ---------------------------------------------------------

    var firstFloorGallery = new FsLightbox();
    firstFloorGallery.props.sources = [
      "/assets/images/office-space/first-floor/first-floor-lg.webp?v=2",
      "/assets/images/office-space/first-floor/f1.webp?v=2",
      "/assets/images/office-space/first-floor/f2.webp?v=2",
      "/assets/images/office-space/first-floor/f3.webp?v=2",
      "/assets/images/office-space/first-floor/f4.webp?v=2",
      "/assets/images/office-space/first-floor/f5.webp?v=2",
      "/assets/images/office-space/first-floor/f6.webp?v=2",
      "/assets/images/office-space/first-floor/f7.webp?v=2",
      "/assets/images/office-space/first-floor/f8.webp?v=2",
      "/assets/images/office-space/first-floor/f9.webp?v=2",
      "/assets/images/office-space/first-floor/f10.webp?v=2",
      "/assets/images/office-space/first-floor/f11.webp?v=2",
    ];

    var firstRows = document.querySelectorAll(".first-floor-table tbody tr");
    var openFirstLinks = document.querySelectorAll(".open-first");

    openFirstLinks.forEach(function (e) {
      e.addEventListener("click", function () {
        firstFloorGallery.open(0);
      });
    });

    firstRows.forEach(function (row) {
      row.addEventListener("click", function (clickEvent) {
        var i = Array.from(row.parentNode.children).indexOf(row);
        var i = i + 1;
        var officeNumber = Number(i);
        var target = clickEvent.currentTarget;
        if (target.classList.contains("gallery-link")) {
          firstFloorGallery.open(officeNumber);
        }
      });
    });

    // Second Floor --------------------------------------------------------

    var secondFloorGallery = new FsLightbox();
    secondFloorGallery.props.sources = [
      "/assets/images/office-space/second-floor/second-floor-lg.webp?v=2",
      "/assets/images/office-space/second-floor/s1.webp?v=2",
      "/assets/images/office-space/second-floor/s2.webp?v=2",
      "/assets/images/office-space/second-floor/s3.webp?v=2",
      "/assets/images/office-space/second-floor/s4.webp?v=2",
      "/assets/images/office-space/second-floor/s5.webp?v=2",
      "/assets/images/office-space/second-floor/s6.webp?v=2",
      "/assets/images/office-space/second-floor/s7.webp?v=2",
      "/assets/images/office-space/second-floor/s8.webp?v=2",
      "/assets/images/office-space/second-floor/s9.webp?v=2",
      "/assets/images/office-space/second-floor/s10.webp?v=2",
      "/assets/images/office-space/second-floor/s11.webp?v=2",
      "/assets/images/office-space/second-floor/s12.webp?v=2",
    ];

    var secondRows = document.querySelectorAll(".second-floor-table tbody tr");
    var openSecondLinks = document.querySelectorAll(".open-second");

    openSecondLinks.forEach(function (e) {
      e.addEventListener("click", function () {
        secondFloorGallery.open(0);
      });
    });

    secondRows.forEach(function (row) {
      row.addEventListener("click", function (clickEvent) {
        var i = Array.from(row.parentNode.children).indexOf(row);
        var i = i + 1;
        var officeNumber = Number(i);
        var target = clickEvent.currentTarget;
        if (target.classList.contains("gallery-link")) {
          secondFloorGallery.open(officeNumber);
        }
      });
    });

    // Lower Ground Floor --------------------------------------------------

    var lowerGroundGallery = new FsLightbox();
    lowerGroundGallery.props.sources = [
      "/assets/images/office-space/lower-ground/lower-ground-lg.webp?v=2",
      "/assets/images/office-space/lower-ground/lg1.webp?v=2",
      "/assets/images/office-space/lower-ground/lg2.webp?v=2",
      "/assets/images/office-space/lower-ground/lg3.webp?v=2",
      "/assets/images/office-space/lower-ground/lg4.webp?v=2",
      "/assets/images/office-space/lower-ground/lg5.webp?v=2",
    ];

    var lowerGroundRows = document.querySelectorAll(
      ".lower-ground-floor-table tbody tr"
    );
    var openLowerGroundLinks = document.querySelectorAll(".open-lower-ground");

    openLowerGroundLinks.forEach(function (e) {
      e.addEventListener("click", function () {
        lowerGroundGallery.open(0);
      });
    });

    lowerGroundRows.forEach(function (row) {
      row.addEventListener("click", function (clickEvent) {
        var i = Array.from(row.parentNode.children).indexOf(row);
        var i = i + 1;
        var officeNumber = Number(i);
        var target = clickEvent.currentTarget;
        if (target.classList.contains("gallery-link")) {
          lowerGroundGallery.open(officeNumber);
        }
      });
    });

    // Site Plan -----------------------------------------------------------

    var sitePlan = new FsLightbox();
    sitePlan.props.sources = [
      "/assets/images/office-space/os-site-plan-lrg.webp?v=2",
    ];

    var openSite = document.querySelector(".open-site");

    openSite.addEventListener("click", function () {
      sitePlan.open(0);
    });
  }
});
